<template>
	<span class="tool-segment"><tool-group v-for="g in segment.groups" :key="g.id" :group="g" @action="replayAction"></tool-group></span>
</template>

<script setup lang="ts">
import ToolGroup from "@/ui/toolbar/ToolGroup.vue";
import {ToolbarSegment} from "@t/ui/Toolbar.ts";

defineProps<{
	segment: ToolbarSegment
}>();
const emit = defineEmits(["action"]);

function replayAction(id: string, arg?: any) {
	emit("action", id, arg);
}
</script>

<style>
.tool-segment {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	column-gap: 12px;
	align-items: baseline;

	&:empty {
		display: none;
	}
}
</style>